import {
    slideUp,
    slideDown,
} from '@js/common/all-functions.js';

document.addEventListener('DOMContentLoaded', (event) => {
    const accordionSections = document.querySelectorAll('.vertical-accordion-section');
    accordionSections.forEach(section => {
        const tabRepet = section.querySelectorAll('.vas-item');

        tabRepet.forEach(tabRepetEle => {
            const title = tabRepetEle.querySelector('.vas-title.-clickable');
            const content = tabRepetEle.querySelector('.vas-desc');

            if (content) {
                title.addEventListener('click', function() {
                    const parent = tabRepetEle.parentElement; // .el-accordion-wrap
                    const isOpen = tabRepetEle.classList.contains('is-active');

                    // Close siblings
                    Array.from(parent.children).forEach(sibling => {
                        if (sibling !== tabRepetEle && sibling.classList.contains('is-active')) {
                            sibling.classList.remove('is-active');
                            const siblingContent = sibling.querySelector('.vas-desc');
                            slideUp(siblingContent);
                        }
                    });

                    // Toggle current
                    if (isOpen) {
                        tabRepetEle.classList.remove('is-active');
                        slideUp(content);
                    } else {
                        tabRepetEle.classList.add('is-active');
                        slideDown(content);

                        setTimeout(() => {
                            // Scroll with custom speed
                            const header = document.querySelector('header'); // Adjust selector
                            const headerHeight = header ? header.offsetHeight : 0;

                            const offset = headerHeight + 100;
                            const rect = tabRepetEle.getBoundingClientRect();
                            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                            const targetY = rect.top + scrollTop - offset;
                            smoothScrollTo(targetY, 800);
                        }, 400);
                    }
                });
            }
        });
    });
});

function smoothScrollTo(targetY, duration = 500) {
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    let startTime = null;

    function animation(currentTime) {
        if (!startTime) {startTime = currentTime;}
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // progress [0,1]

        // Easing (easeInOutQuad)
        const ease = progress < 0.5 ?
            2 * progress * progress :
            -1 + (4 - 2 * progress) * progress;

        window.scrollTo(0, startY + distance * ease);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }

    requestAnimationFrame(animation);
}
